import React, { useState } from 'react';
import { 
  Sparkles, FileText, Presentation, Users, ScrollText, 
  Download, Loader2, Brain, ChevronRight, Target, Send, 
  LayoutTemplate, CheckCircle, AlertTriangle
} from 'lucide-react';
import EditableAIBox from './EditableAIBox';
// Hook kuralı hatasını aşmak için ismi consumeCredit olarak değiştirildi
import { useCredit as consumeCredit } from '../firebase';

const AI_API_URL = "https://generateanalysis-yyf3isw5zq-uc.a.run.app";
// YENİ EKLENEN: AI Atölyesi için özel, güvenli backend adresimiz
const WORKSHOP_API_URL = "https://us-central1-rehber360-e0808.cloudfunctions.net/generateWorkshopContent";

const AIWorkshop = ({ user, onUpgrade }) => {
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [generatedContent, setGeneratedContent] = useState(null);

  // ÖNCE Form Stateleri TANIMLANMALI
  const [category, setCategory] = useState('');
  const [audience, setAudience] = useState('');
  const [level, setLevel] = useState('');
  const [topic, setTopic] = useState('');
  const [interventionType, setInterventionType] = useState('Bireysel Danışma');
  const [approach, setApproach] = useState('BDT (Bilişsel Davranışçı)');
  const [sessionCount, setSessionCount] = useState('4 Oturum');
  const [customTopic, setCustomTopic] = useState('');

  // SONRA Limit ve Sayaç Kontrolleri Yapılmalı (Çünkü category'yi kullanıyor)
  const [usageLimits, setUsageLimits] = useState(() => {
    const stored = localStorage.getItem(`ai_usage_${user?.uid}`);
    return stored ? JSON.parse(stored) : { brosur: 0, sunum: 0, etkinlik: 0, rapor: 0, klinik: 0 };
  });

  const currentUsage = usageLimits[category] || 0;
  const isLimitReached = !user?.isPremium && currentUsage >= 4;

  const categories = [
    { id: 'brosur', name: 'Veli/Öğrenci Broşürü', icon: FileText, desc: 'Bilgilendirici ve samimi bir dil.' },
    { id: 'sunum', name: 'Seminer & Sunum', icon: Presentation, desc: 'Slayt bazlı, yapılandırılmış taslak.' },
    { id: 'etkinlik', name: 'Sınıf İçi Etkinlik', icon: Users, desc: 'Pedagojik, oyunlaştırma ve etkileşimli.' },
    { id: 'tutanak', name: 'Resmi Tutanak/Rapor', icon: ScrollText, desc: 'Akademik, resmi ve objektif bir dil.' },
    { id: 'klinik', name: 'Psikolojik Danışma Oturumu', icon: Brain, desc: 'BDT, ACT, REBT ile yapılandırılmış plan.' }
  ];

  const handleGenerate = async () => {
    // 1. ZIRH: Kategori seçilmemişse uyar
    if (!category) {
      alert("Lütfen önce sol üstten bir İçerik Türü seçiniz.");
      return;
    }

    // 2. ZIRH: Klinik modundaysak sadece klinik alanları kontrol et
    if (category === 'klinik') {
      if (!customTopic.trim()) {
        alert("Lütfen odak sorunu veya vaka özetini yazınız.");
        return;
      }
    } 
    // 3. ZIRH: Diğer modlardaysak eski alanları kontrol et
    else {
      if (!audience || !level || !topic.trim()) {
        alert("Lütfen yapay zekanın doğru üslubu bulabilmesi için Hedef Kitle, Kademe ve Konu alanlarını doldurun.");
        return;
      }
    }

    // 🛡️ YENİ ZIRH: KATEGORİ (SEKME) BAZLI KULLANIM LİMİTİ (4 Hak)
    if (isLimitReached) {
        alert("Bu kategori için ücretsiz kullanım hakkınızı (4/4) doldurdunuz. Sınırsız üretim için Premium'a geçin!");
        if (onUpgrade) onUpgrade(); // Limit dolduysa Premium Satış sayfasına fırlat
        return;
    }

    setLoading(true);
    setGeneratedContent(null); // Önceki içeriği temizle
    
try {
      // FRONTEND TERTEMİZ: Sadece kullanıcının girdiği parametreleri paketleyip güvenli kasaya fırlatıyoruz!
      const res = await fetch(WORKSHOP_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          category,
          audience,
          level,
          topic,
          interventionType,
          approach,
          sessionCount,
          customTopic,
          userId: user?.uid // 🛡️ KİMLİK KARTIMIZ NİHAYET BURADA!
        })
      });

      if (!res.ok) {
        // 🚀 YENİ HATA YAKALAYICI: Kredi bittiyse anlamsız sunucu hatası yerine şık uyarı
        const errData = await res.json().catch(() => ({})); 
        if (errData.error === "INSUFFICIENT_CREDITS") {
            throw new Error("⚠️ Atölye üretimi için krediniz yetersiz! Lütfen Premium pakete geçin.");
        }
        throw new Error(errData.error || "Sunucu hatası");
      }

      const data = await res.json();
      
      // Gelen sihirli metni ekrana bas!
      setGeneratedContent(data.result);
    // 🚀 SİHİRLİ DOKUNUŞ: Üretim başarılıysa sayacı 1 artır ve tarayıcıya kaydet
      if (!user?.isPremium) {
        setUsageLimits(prev => {
          const newLimits = { ...prev, [category]: (prev[category] || 0) + 1 };
          localStorage.setItem(`ai_usage_${user?.uid}`, JSON.stringify(newLimits));
          return newLimits;
        });
      }

    } catch (error) {
      console.error("AI Üretim Hatası:", error);
      alert("İçerik üretilirken bir hata oluştu: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadPDF = () => {
    setDownloading(true);
    const content = document.getElementById('ai-workshop-print-area').innerHTML;
    const iframe = document.createElement('iframe');

    // Mobil Safari Beyaz Ekran Koruması
    iframe.style.position = 'fixed';
    iframe.style.bottom = '0';
    iframe.style.right = '0';
    iframe.style.width = '1024px';
    iframe.style.height = '100vh';
    iframe.style.opacity = '0.01';
    iframe.style.pointerEvents = 'none';
    iframe.style.zIndex = '-1';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    
    // Tailwind stillerini saniyesinde klonla
    let stylesHTML = '';
    document.querySelectorAll('style, link[rel="stylesheet"]').forEach(el => {
        stylesHTML += el.outerHTML;
    });

    const printDate = new Date().toLocaleDateString('tr-TR');
    const docType = categories.find(c => c.id === category)?.name || 'PDR Dokümanı';

    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${docType}</title>
          ${stylesHTML}
          <style>
            @media print {
              @page { size: A4 portrait; margin: 10mm; } /* Kenar boşlukları daraltıldı */
              body { font-family: 'Segoe UI', sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; background: white; color: black; }
              .no-print { display: none !important; }
              .prose { max-width: none !important; font-size: 11px !important; line-height: 1.3 !important; }
              h1, h2, h3 { margin-top: 10px !important; margin-bottom: 4px !important; }
            }
          </style>
        </head>
        <body class="bg-white text-black p-8 pt-4">
          <table style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr>
                <td>
                  <div style="border-bottom: 2px solid #cbd5e1; padding-bottom: 15px; margin-bottom: 20px; display: flex; justify-content: space-between; align-items: flex-end;">
                      <div>
                          <h2 style="font-size: 24px; font-weight: 900; color: #0f172a; margin: 0; letter-spacing: -0.5px;">Rehber360</h2>
                          <p style="font-size: 11px; color: #64748b; font-weight: bold; text-transform: uppercase; margin-top: 4px; letter-spacing: 1px;">Profesyonel PDR İçerik Sistemi</p>
                      </div>
                      <div style="text-align: right;">
                          <p style="font-size: 13px; font-weight: bold; color: #334155; margin: 0; text-transform: uppercase;">${docType}</p>
                          <p style="font-size: 10px; color: #94a3b8; margin-top: 4px; font-weight: bold;">Tarih: ${printDate}</p>
                      </div>
                  </div>
                </td>
              </tr>
            </thead>
            
            <tbody>
              <tr>
                <td>
                  <div class="prose max-w-none text-[13px] leading-relaxed text-slate-800">
                    ${content}
                  </div>
                </td>
              </tr>
            </tbody>

            
          </table>
        </body>
      </html>
    `);
    doc.close();

    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    
    setDownloading(false);

    // Arka plan temizliği
    setTimeout(() => {
      if (document.body.contains(iframe)) {
         document.body.removeChild(iframe);
      }
    }, 999000000);
  };

  return (
    <div className="h-[calc(100vh-120px)] flex flex-col lg:flex-row gap-6 animate-in fade-in duration-500">
      
      {/* SOL PANEL: KONTROL ODASI */}
      <div className="w-full lg:w-1/3 bg-white rounded-[2rem] p-6 md:p-8 shadow-sm border border-slate-200 overflow-y-auto custom-scrollbar flex flex-col h-full shrink-0">
        <div className="mb-6 border-b border-slate-100 pb-4">
          <h2 className="text-2xl font-black text-slate-800 flex items-center tracking-tight">
            <Sparkles className="h-6 w-6 mr-2 text-purple-600" /> AI Atölyesi
          </h2>
          <p className="text-sm text-slate-500 mt-1 font-medium">Saniyeler içinde profesyonel PDR içerikleri üretin.</p>
        </div>

        <div className="space-y-6 flex-1">
          {/* 1. Kategori */}
          <div>
            <label className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3 block">1. İçerik Türü</label>
            <div className="grid grid-cols-1 gap-3">
              {categories.map(c => (
                <div 
                  key={c.id} 
                  onClick={() => setCategory(c.id)}
                  className={`p-3 rounded-xl border-2 cursor-pointer transition-all flex items-center ${category === c.id ? 'border-purple-500 bg-purple-50 shadow-sm' : 'border-slate-100 hover:border-purple-200 hover:bg-slate-50'}`}
                >
                  <div className={`h-10 w-10 rounded-lg flex items-center justify-center mr-3 ${category === c.id ? 'bg-purple-200 text-purple-700' : 'bg-slate-100 text-slate-500'}`}>
                    <c.icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h4 className={`font-bold text-sm ${category === c.id ? 'text-purple-900' : 'text-slate-700'}`}>{c.name}</h4>
                    <p className="text-[10px] text-slate-500">{c.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {category === 'klinik' ? (
            /* 🌟 YENİ: KLİNİK TASARIMCI ARAYÜZÜ 🌟 */
            <div className="space-y-5 animate-in fade-in duration-300">
              <div className="bg-purple-50 p-4 rounded-xl border border-purple-100">
                <h4 className="font-bold text-purple-900 text-sm mb-1 flex items-center"><Brain className="h-4 w-4 mr-2"/> Süpervizör Kurulumu</h4>
                <p className="text-[11px] text-purple-700">Seçtiğiniz ekole ve oturum sayısına uygun klinik plan üretilecektir.</p>
              </div>

              {/* Müdahale Türü */}
              <div>
                <label className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2 block">Müdahale Türü</label>
                <div className="flex gap-2">
                  {['Bireysel Danışma', 'Grupla Psikoeğitim'].map(type => (
                    <button key={type} onClick={() => setInterventionType(type)} className={`flex-1 py-2.5 rounded-xl border text-xs font-bold transition ${interventionType === type ? 'bg-purple-600 border-purple-600 text-white shadow-md' : 'bg-white border-slate-200 text-slate-600 hover:border-purple-300'}`}>{type}</button>
                  ))}
                </div>
              </div>

              {/* Ekol / Yaklaşım */}
              <div>
                <label className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2 block">Terapötik Ekol</label>
                <select value={approach} onChange={e => setApproach(e.target.value)} className="w-full p-3 rounded-xl border border-slate-200 text-sm font-bold text-slate-700 outline-none focus:ring-2 focus:ring-purple-500 bg-white cursor-pointer shadow-sm">
                  <option value="BDT (Bilişsel Davranışçı)">BDT (Bilişsel Davranışçı)</option>
                  <option value="ACT (Kabul ve Kararlılık)">ACT (Kabul ve Kararlılık)</option>
                  <option value="REBT (Albert Ellis - ADDT)">REBT (Albert Ellis - ADDT)</option>
                  <option value="Oyun Terapisi Teknikleri (İlkokul)">Oyun Terapisi Teknikleri (İlkokul)</option>
                  <option value="Çözüm Odaklı (ÇÖKST)">Çözüm Odaklı (ÇÖKST)</option>
                </select>
              </div>

              {/* Oturum Sayısı */}
              <div>
                <label className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2 block">Oturum Planı</label>
                <div className="flex gap-2">
                  {['1 (Acil)', '4 Oturum', '8 Oturum'].map(count => (
                    <button key={count} onClick={() => setSessionCount(count)} className={`flex-1 py-2.5 rounded-xl border text-xs font-bold transition ${sessionCount === count ? 'bg-purple-600 border-purple-600 text-white shadow-md' : 'bg-white border-slate-200 text-slate-600 hover:border-purple-300'}`}>{count}</button>
                  ))}
                </div>
              </div>

              {/* Odak Sorun / Vaka */}
              <div className="flex-1 flex flex-col">
                <label className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2 block">Vaka Özeti / Odak Sorun</label>
                <textarea 
                  value={customTopic} 
                  onChange={e => setCustomTopic(e.target.value)} 
                  placeholder="Örn: Sınav kaygısı, akran zorbalığı, mükemmeliyetçilik..."
                  className="w-full p-4 rounded-xl border border-slate-200 text-sm font-medium text-slate-700 outline-none focus:ring-2 focus:ring-purple-500 bg-white resize-none h-20 shadow-inner custom-scrollbar"
                />
              </div>
            </div>
          ) : (
            /* 🌟 ESKİ STANDART ARAYÜZ (Broşür, Etkinlik vb. için aynen korundu) 🌟 */
            <div className="space-y-6">
              {/* 2. Hedef Kitle & Kademe (Yan Yana) */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2 block">Hedef Kitle</label>
                  <select value={audience} onChange={(e) => setAudience(e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-bold text-slate-700 focus:ring-2 focus:ring-purple-500 outline-none">
                    <option value="">Seçiniz...</option>
                    <option value="öğrenci">Öğrenciler</option>
                    <option value="veli">Veliler</option>
                    <option value="öğretmen">Öğretmenler</option>
                    <option value="idare">Okul İdaresi / Kurul</option>
                  </select>
                </div>
                <div>
                  <label className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2 block">Kademe</label>
                  <select value={level} onChange={(e) => setLevel(e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-bold text-slate-700 focus:ring-2 focus:ring-purple-500 outline-none">
                    <option value="">Seçiniz...</option>
                    <option value="okul_öncesi">Okul Öncesi</option>
                    <option value="ilkokul">İlkokul</option>
                    <option value="ortaokul">Ortaokul</option>
                    <option value="lise">Lise</option>
                    <option value="genel">Kademe Bağımsız</option>
                  </select>
                </div>
              </div>

              {/* 3. Konu ve Talimat */}
              <div className="flex-1 flex flex-col min-h-[150px]">
                <label className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2 block flex items-center justify-between">
                  <span>3. Konu ve Odak Noktası</span>
                </label>
                <textarea 
                  value={topic}
                  onChange={(e) => setTopic(e.target.value)}
                  className="w-full flex-1 p-4 bg-slate-50 border border-slate-200 rounded-xl text-sm text-slate-700 focus:ring-2 focus:ring-purple-500 focus:bg-white outline-none resize-none custom-scrollbar"
                  placeholder="Örn: İlkokul öğretmenleri için sınıf iklimini güçlendirme ve akran zorbalığını önleme sunum taslağı..."
                ></textarea>
              </div>
            </div>
          )}
        </div>

        {/* Üret Butonu */}
        <div className="mt-6 pt-4 border-t border-slate-100">
          <button 
            onClick={isLimitReached ? onUpgrade : handleGenerate} 
            disabled={loading}
            className={`w-full py-4 rounded-xl font-black text-sm transition-all shadow-lg flex items-center justify-center relative overflow-hidden
              ${isLimitReached 
                ? 'bg-slate-800 text-white hover:bg-slate-900 shadow-slate-200 ring-2 ring-pink-500' 
                : 'bg-purple-600 hover:bg-purple-700 text-white shadow-purple-200'}`}
          >
            {loading ? <Loader2 className="animate-spin h-5 w-5 mr-2 relative z-10"/> : <Send className="h-5 w-5 mr-2 relative z-10"/>}
            <span className="relative z-10">
              {isLimitReached ? "LİMİT DOLDU - PREMİUM'A GEÇ" : loading ? "Yapay Zeka İçeriği Dokuyor..." : "İçeriği Üret"}
            </span>

            {/* ÜCRETSİZ KULLANICI İÇİN KALAN HAK GÖSTERGESİ */}
            {!user?.isPremium && category && !isLimitReached && (
                <div className="absolute top-0 right-0 bg-black/20 text-[10px] px-3 py-1 rounded-bl-xl rounded-tr-xl font-bold text-white">
                  Kalan: {2 - currentUsage}
                </div>
            )}
          </button>
        </div>
      </div>

      {/* SAĞ PANEL: REHBER360 CANVAS */}
      <div className="w-full lg:w-2/3 bg-slate-50 rounded-[2rem] border border-slate-200 shadow-inner flex flex-col h-full overflow-hidden relative">
        
        {/* Canvas Header */}
        <div className="bg-white px-6 py-4 border-b border-slate-200 flex justify-between items-center z-10 shadow-sm">
          <div className="flex items-center">
            <div className="h-8 w-8 bg-purple-100 rounded-lg flex items-center justify-center mr-3 text-purple-600">
              <LayoutTemplate className="h-4 w-4" />
            </div>
            <div>
              <h3 className="font-bold text-slate-800 text-sm">Rehber360 Çalışma Alanı</h3>
              <p className="text-[10px] text-slate-400 font-medium">{generatedContent ? "İçerik hazır, düzenlenebilir." : "Talimatlarınızı bekliyor."}</p>
            </div>
          </div>
          
          <button 
            onClick={handleDownloadPDF}
            disabled={!generatedContent || downloading}
            className="px-4 py-2 bg-slate-900 hover:bg-blue-600 text-white rounded-lg font-bold text-xs transition-colors flex items-center shadow-md disabled:opacity-50 disabled:hover:bg-slate-900"
          >
            {downloading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Download className="h-4 w-4 mr-2" />}
            {downloading ? "Hazırlanıyor..." : "Resmi PDF İndir"}
          </button>
        </div>

        {/* Canvas İçerik (Boş veya Dolu) */}
        <div className="flex-1 overflow-y-auto p-6 md:p-8 custom-scrollbar bg-slate-50/50">
          {!generatedContent && !loading ? (
            <div className="h-full flex flex-col items-center justify-center text-slate-400">
              <Brain className="h-20 w-20 mb-6 opacity-20 text-purple-500" />
              <h3 className="text-xl font-black text-slate-700 mb-2">Atölye Boş</h3>
              <p className="text-sm font-medium max-w-sm text-center">Sol panelden parametreleri belirleyin ve "İçeriği Üret" butonuna basarak yapay zekayı harekete geçirin.</p>
            </div>
          ) : loading ? (
             <div className="h-full flex flex-col items-center justify-center">
                <div className="relative">
                  <div className="absolute inset-0 bg-purple-400 blur-xl opacity-20 animate-pulse rounded-full"></div>
                  <Brain className="h-16 w-16 text-purple-600 animate-bounce relative z-10" />
                </div>
                <p className="mt-6 font-bold text-purple-900 tracking-widest uppercase text-sm animate-pulse">SİHİR GERÇEKLEŞİYOR...</p>
             </div>
          ) : (
            <div id="ai-workshop-print-area" className="bg-white border border-slate-200 rounded-2xl shadow-sm p-2 animate-in slide-in-from-bottom-4 duration-500">
  <EditableAIBox text={generatedContent} isOfficial={category === 'tutanak'} />
</div>
          )}
        </div>
      </div>
      
    </div>
  );
};

export default AIWorkshop;